import React, { useState } from 'react';
import { FormFeedback, Input, InputProps } from 'reactstrap';
import { Eye, EyeOff } from 'react-feather';

interface PasswordInputProps extends Omit<InputProps, 'type'> {
  invalidMessage?: string;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  invalidMessage,
  ...props
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <div className="d-flex position-relative">
      <Input
        {...props}
        type={isPasswordVisible ? 'text' : 'password'}
        // removes error icon
        style={{ backgroundImage: 'none' }}
      />
      {props.invalid && !!invalidMessage && (
        <FormFeedback tooltip>{invalidMessage}</FormFeedback>
      )}
      <div
        onClick={() => setIsPasswordVisible((prev) => !prev)}
        className="d-flex position-absolute top-0 right-0 h-100 align-items-center mr-1"
      >
        {isPasswordVisible ? <EyeOff size={16} /> : <Eye size={16} />}
      </div>
    </div>
  );
};
